import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api, { fmtErr } from "../api/axios";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pwd, setPwd] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pwd.length < 10) return setError("Password must be at least 10 characters");
    if (!/[A-Z]/.test(pwd)) return setError("Password must contain at least one uppercase letter");
    if (!/[a-z]/.test(pwd)) return setError("Password must contain at least one lowercase letter");
    if (!/[0-9]/.test(pwd)) return setError("Password must contain at least one digit");
    if (!/[^A-Za-z0-9]/.test(pwd)) return setError("Password must contain at least one special character");
    if (pwd !== confirm) return setError("Passwords do not match");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pwd });
      setDone(true);
    } catch (err) { setError(fmtErr(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="login-shell">
      <div className="login-bg" />
      <div className="login-card">
        <div className="brand">
          <div className="brand-mark">S</div>
          <div><div className="brand-name">Snehworld CRM</div><div className="brand-sub">Password Reset</div></div>
        </div>
        {done ? (
          <div data-testid="reset-done">
            <h2 className="login-title">Password updated</h2>
            <p className="login-sub">You can now sign in with your new password.</p>
            <button className="btn-primary w-full" onClick={() => navigate("/login")} data-testid="reset-goto-login">Go to sign in</button>
          </div>
        ) : !token ? (
          <div className="error-box" data-testid="reset-no-token">Invalid reset link — no token provided.</div>
        ) : (
          <form onSubmit={submit} className="login-form">
            <h2 className="login-title">Set a new password</h2>
            <div className="form-group">
              <label className="form-label">New password</label>
              <input type="password" className="form-input" value={pwd} onChange={(e) => setPwd(e.target.value)} required autoFocus data-testid="reset-pwd-input" />
            </div>
            <div className="form-group">
              <label className="form-label">Confirm password</label>
              <input type="password" className="form-input" value={confirm} onChange={(e) => setConfirm(e.target.value)} required data-testid="reset-confirm-input" />
            </div>
            {error && <div className="error-box" data-testid="reset-error">{error}</div>}
            <button type="submit" className="btn-primary w-full" disabled={loading} data-testid="reset-submit-btn">
              {loading ? "Updating..." : "Update password"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
